import {ColumnMain} from "#/models/column-main";
import {Column} from "#/models/column";
import {Trans} from "@lingui/macro";
import {Tag} from "antd";
import React from "react";

const OrderModel = () : ColumnMain => {

    const columns : Array<Column> = new Array();
    
    columns.push({key:'orderNo', width: 150, filter:true, sorter:true, title:<Trans>Order No</Trans>});
    columns.push({key:'orderDate', width: 150, dateFilter:true, sorter:true, title:<Trans>Order Date</Trans>});
    columns.push({key:'deliveryDate', width: 150, dateFilter:true, sorter:true, title:<Trans>Delivery Date</Trans>});
    columns.push({key:'item.itemNo', dataIndex: ['item', 'itemNo'], width: 150, filter:true, sorter:true, title:<Trans>Item No</Trans>});
    columns.push({key:'item.name', dataIndex: ['item', 'name'], width: 200, filter:true, sorter:true, title:<Trans>Item Name</Trans>});
    columns.push({key:'orderQuantity', width: 158, filter:true, sorter:true, title:<Trans>Order Quantity</Trans>});
    columns.push({key:'receivedQuantity', width: 171, filter:true, sorter:true, title:<Trans>Received Quantity</Trans>});
    columns.push({key:'status', width: 130, filter:true, sorter:true, title:<Trans>Status</Trans>});
    columns.push({key:'updatedDate', width: 180, dateTimeFilter:true, sorter:true, title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 150, filter:true, sorter:true, title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 180, dateTimeFilter:true, sorter:true, title:<Trans>Created Date</Trans>, direction:"desc"});
    columns.push({key:'createdBy', width: 150, filter:true, sorter:true, title:<Trans>Created By</Trans>});

    return{
        columns:columns,
        url:"/resource/orders"
    };

}
export default OrderModel();
